// Recovered compiled webpack factory 16486. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return Object.prototype.toString.call(e);
  }
  function n(e) {
    if ("[object Object]" !== r(e)) return !1;
    let t = Object.getPrototypeOf(e);
    return null === t || t.hasOwnProperty("isPrototypeOf");
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getObjectClassLabel: function () {
        return r;
      },
      isPlainObject: function () {
        return n;
      },
    }));
}
